import { Component, type ReactNode } from 'react';
import { ErrorState } from './Feedback';

/** Isolate a failed page/chunk so the user can still navigate elsewhere. */
export class PageErrorBoundary extends Component<{children: ReactNode}, {failed: boolean}> {
  state = {failed: false};

  static getDerivedStateFromError() {
    return {failed: true};
  }

  render() {
    if (this.state.failed) {
      return <ErrorState error={new Error('当前页面暂时无法显示。可切换其他菜单，或重新加载页面。')}
        onRetry={() => window.location.reload()} />;
    }
    return this.props.children;
  }
}
